/**
 * @module conversations ui
 */
import { createReducer } from '@reduxjs/toolkit';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { conversationsActions } from '~/behaviors/actions/conversations.actions';
import { handleUnsafeOptionalChaining } from '~/tools/lint/handleUnsafeOptionalChaining';

const defaultState = {
  isLoadingConversations: false,
  isLoadingConversationMessages: false,
  error: null,
};

const reset = () => defaultState;

const merge = (updates) => (state) => ({
  ...state,
  ...updates,
});

const mergeWithError = (updates) => (state, action) => {
  const { name, message } = handleUnsafeOptionalChaining(action?.error);

  return {
    ...state,
    ...updates,
    error: {
      name,
      message,
    },
  };
};

const conversationsUI = createReducer(defaultState, (builder) => {
  builder.addCase(metaActions.reset, reset);

  builder.addCase(conversationsActions.fetchConversationList.pending, merge({ isLoadingConversations: true }));
  builder.addCase(conversationsActions.fetchConversationList.fulfilled, merge({ isLoadingConversations: false }));
  builder.addCase(
    conversationsActions.fetchConversationList.rejected,
    mergeWithError({ isLoadingConversations: false }),
  );

  builder.addCase(
    conversationsActions.fetchConversationMessages.pending,
    merge({ isLoadingConversationMessages: true }),
  );
  builder.addCase(
    conversationsActions.fetchConversationMessages.fulfilled,
    merge({ isLoadingConversationMessages: false }),
  );
  builder.addCase(
    conversationsActions.fetchConversationMessages.rejected,
    mergeWithError({ isLoadingConversationMessages: false }),
  );

  builder.addCase(conversationsActions.resetConversationsPageErrors, merge({ error: null }));
  builder.addCase(conversationsActions.resetConversationsPageStates, reset);
});

export default conversationsUI;
